import { qs } from '@fluorescent/dom';

import { section } from '@/glow';
import Carousel from '@/lib/carousel';

const selectors = {
  recommendations: '[data-recommendations]',
  slider: '[data-slider]',
};

section('recommended-products', {
  onLoad() {
    const { limit, productId: id, sectionId } = this.container.dataset;

    const content = qs(selectors.recommendations, this.container);
    if (!content) return;

    const requestUrl = `${window.theme.routes.productRecommendations}?section_id=${sectionId}&limit=${limit}&product_id=${id}`;

    const request = new XMLHttpRequest();
    request.open('GET', requestUrl, true);

    request.onload = () => {
      if (request.status >= 200 && request.status < 300) {
        let container = document.createElement('div');
        container.innerHTML = request.response;

        // Check if the response includes a product item
        // and if it doesn't remove the entire section
        const item = qs('.product-item', container);
        if (!item) {
          this.container.parentNode.removeChild(this.container);
          return;
        }

        content.innerHTML = qs(selectors.recommendations, container).innerHTML;

        const carousel = qs(selectors.slider, content);
        const carouselWraps = carousel.dataset.carouselWraps === 'true';

        if (carousel) {
          this.carousel = Carousel(content, {
            wrapAround: carouselWraps,
          });
        }
      } else {
        // If request returns any errors remove the section markup
        this.container.parentNode.removeChild(this.container);
      }
    };
    request.send();
  },
  onUnload() {
    this.carousel.destroy();
  },
});
